import styled from 'styled-components';

import { NeutralColors } from '@/theme';

export const Container = styled.div`
  width: 300px;
  padding: 20px;
  background: ${NeutralColors[0]};
  border-radius: ${({ theme }) => theme.borderRadius}px;
`;
